var map = {
	"./arrow-down.svg": 1088,
	"./arrow-right.svg": 1089,
	"./card-list.svg": 1090,
	"./card.svg": 1091,
	"./file.svg": 1092,
	"./home-light.svg": 1093,
	"./home.svg": 1094,
	"./love.svg": 1095,
	"./my-light.svg": 1096,
	"./my.svg": 1097,
	"./patient-light.svg": 1098,
	"./patient.svg": 1099,
	"./qr.svg": 1100,
	"./zoom.svg": 1101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;